class FetchArt {
  constructor(el, fetched = false) {
    this.el = el
    this.fetched = fetched
    this.open = false
    if (window.location.href.includes('singleurl') && !this.fetched) {
      this.fetched = true
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      let url = urlParams.get('singleurl')
      let lang = window.location.pathname.split('/')[1]

      if (lang) {
        this.url = `${window.location.origin}/${lang}/${url}`
      } else {
        this.url = `${window.location.origin}/${url}`
      }

      this.fetchData(this.url)
    }

    this.initialize()
  }

  initialize() {
    this.bindUI()
    if (this.el != undefined) {
      this.bindEvents()
    }
  }

  bindUI() {
    this.ui = {}
    this.ui.$panel = document.querySelector('.js-single-panel')
    this.ui.$panelInner = document.querySelector('.js-single-inner')
  }

  bindEvents() {
    this.el.addEventListener('click', this.onClick.bind(this))
  }
  trapFocus(container) {    
    if (this.focusHandler) {
        this.currentContainer.removeEventListener('keydown', this.focusHandler);
    }

    this.currentContainer = container;
    if (!window.oldFocus) {
      window.oldFocus = document.activeElement
    }
    this.focusHandler = (e) => {
        const focusableElements = container.querySelectorAll('button,a');
        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (e.key === 'Tab') {
            if (e.shiftKey && document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
            } else if (!e.shiftKey && document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
            }
        }
    };
    const focusableElements = container.querySelectorAll('button,a');
    
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    firstElement.focus()
    this.currentContainer.addEventListener('keydown', this.focusHandler);
}
  onClick(e) {
    e.preventDefault()
    let target = e.currentTarget
    if ( !target.matches('.js-art-link') ) return

    let url = target.getAttribute('data-href')

    if(this.ui.$panelInner.hasChildNodes()) {
      this.ui.$panelInner.style.opacity = '0'
      this.ui.$panelInner.innerHTML = ""
    }

    this.fetchData(url)
  }

  onClose(e) {
    e.preventDefault()
    let target = e.currentTarget
    if ( !target.matches('.js-back') ) return

    if (window.location.href.includes('singleurl')) {
      window.history.replaceState({'page': 'home'}, '', `${window.location.origin}/${window.location.hash}`)
    }

    this.ui.$panel.classList.remove('is-visible')
    const prev = window.oldFocus
    window.oldFocus = null
    if (prev && typeof prev.focus === 'function') {
      try {
        prev.focus()
      } catch (_) {}
    }
  }

  async fetchData(url) {
    await fetch(url)
      .then(response => response.text())
      .then(html => {
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      let content = doc.querySelector('main').innerHTML

      this.ui.$panelInner.style.opacity = '1'
      this.ui.$panelInner.innerHTML = content
    })
    .then(() => {
      this.ui.$panel.classList.add('is-visible')
      if(this.ui.$panel.querySelector('.post-type-collection')) {
        this.ui.$panel.classList.remove('single-artwork')
        this.ui.$panel.classList.add('single-collection')
      } else {
        this.ui.$panel.classList.add('single-artwork')
        this.ui.$panel.classList.remove('single-collection')

      }
    })
    .then(() => {
      window.animate.initialize()
      window.lazyvideo.initialize()
      this.trapFocus(this.ui.$panel)
      let close = this.ui.$panelInner.querySelector('.js-back')
      let nextLinks = [...this.ui.$panelInner.querySelectorAll('.js-art-link')]
      close.addEventListener('click', this.onClose.bind(this))

      nextLinks.forEach(link => {
        link.addEventListener('click', this.onClick.bind(this))
      })
    })
    .catch((error) => {
      console.error('Error:', error)
    })
  }
}

export default FetchArt
